<template>
  <div class="moral-students m-0-16 fb fb-wrap bd-box">
    <div
      v-for="(item, index) in dataList"
      @click="handlerClick(item)"
      :key="`moral-student${index}`"
      class="bg-FFFFFF mb-20 p-12-0 p-0-16 h-106 bd-radio-6 bd-box moral-student"
      :class="{ 'mr-16': index % 2 === 0 }"
    >
      <div class="fb fb-cross-center mb-8">
        <div
          class="inline-block w-28 h-28 bd-p-50 bg-006AFE c-FFFFFF font-22 item-shrink-0"
          ><div
            class="width-full height-full fb fb-cross-center fb-main-center"
            >{{ nameLastTwoWords(item.studentName) }}</div
          ></div
        ><span class="ml-8 mr-4 font-30 nowrap text-ellipsis">{{
          item.studentName
        }}</span
        ><span
          class="font-28 iconfont"
          v-show="+item.gender"
          :style="{
            color: +item.gender === 1 ? '#006AFE' : '#FF4D94'
          }"
          >{{ +item.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
        >
      </div>
      <div class="fb fb-row fb-cross-center fb-main-between">
        <div class="item-flex-1 pl-16">
          <p class="font-24 c-171A1D-56 mb-4">表扬</p>
          <p class="font-36 c-006AFE ff-medium"
            >{{ +item.totalPraiseScore > 0 ? '+' : ''
            }}{{ item.totalPraiseScore }}</p
          >
        </div>
        <div class="item-flex-1 pl-16">
          <p class="font-24 c-171A1D-56 mb-4">待改进</p>
          <p class="font-36 c-171A1D-85 ff-medium">{{
            item.totalNeedImproveScore
          }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nameLastTwoWords } from '@/utils/comUtils'
export default {
  components: {},
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      nameLastTwoWords
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClick(item) {
      this.$emit('click', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.moral-student {
  width: calc(50% - 8px);
}
</style>
